import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderCardInfoComponent } from './order-card-info.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatDividerModule } from '@angular/material/divider';



@NgModule({
  declarations: [
    OrderCardInfoComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    MatDividerModule
  ],
  exports: [
    OrderCardInfoComponent
  ]
})
export class OrderCardInfoModule { }
